import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import HiddenAccess from './HiddenAccess';
import QuickAccess from './QuickAccess';
import UrlAccess from './UrlAccess';

interface LandingLayoutProps {
  children: React.ReactNode;
}

const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  return (
    <Box>
      <UrlAccess />
      <Navbar />
      <Box id="hero">
        {children}
      </Box>
      <HiddenAccess />
      <QuickAccess />
    </Box>
  );
};

export default LandingLayout;

